import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import map from 'lodash/map';
import EmailGroupFrequency from 'account/components/email_group_frequency';
import { updateEmailGroup, updateSettings } from 'account/ducks/notification_settings';

export function mapStateToProps({ notificationSettings }) {
  const { frequencies } = notificationSettings.options;
  const { email_group } = notificationSettings.data;
  const keys = Object.keys(email_group);

  return {
    value: keys.length ? email_group[keys[0]] : '',
    frequencies: map(frequencies, (freq, key) => ({ label: freq, value: key * 1 })),
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onChange: updateEmailGroup,
    updateSettings,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailGroupFrequency);



// WEBPACK FOOTER //
// ./account/containers/email_group_frequency.js